import { Select, Option } from "@material-tailwind/react";

const LanguageSelect = ({ language, setLanguage }) => {

    return (
        <div className="w-full max-w-32">
            <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm"
            >
                <option value="english">English</option>
                <option value="sinhala">Sinhala</option>
            </select>
            {/* <Select
                label="Select Language"
                value={language}
                onChange={(val) => setLanguage(val)}
                
            >
                <Option value="english">English</Option>
                <Option value="sinhala">Sinhala</Option>
            </Select> */}
        </div>
    )
}

export default LanguageSelect